(function() {
  // ===== 1. Détection langue et ajout classe body =====
  const path = window.location.pathname;
  let lang = 'fr';
  if (path.startsWith('/en')) lang = 'en';
  else if (path.startsWith('/ar')) lang = 'ar';
  document.body.classList.add('lang-' + lang);
  // ===== 2. Footer scroll-top pour liens =====
  if (!path.includes('/collections/')) {
    document.querySelectorAll('.footer-new a[href]').forEach(link => {
      link.addEventListener('click', () => setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }, 50));
    });
  }
  // ===== 3. Compteur panier =====
  if (!path.includes('/collections/')) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const bubble = document.querySelector('#cart-icon-bubble');
        if (!bubble) return;
        bubble.innerHTML = cart.item_count > 0
          ? `<div class="header__cart-count absolute bg-theme-text text-theme-bg text-center">
               <span aria-hidden="true" class="header__cart-count-number">${cart.item_count}</span>
               <span class="visually-hidden">${cart.item_count} articles</span>
             </div>`
          : '';
      });
  }
  // ===== 4. Restauration scroll & HTML collection =====
  if (/\/collections\//.test(path)) {
    const key = 'collection_state_test';
    document.addEventListener('click', e => {
      const link = e.target.closest('a');
      if (!link || !link.href.includes('/products/')) return;
      const grid = document.querySelector('#filter-results ul.grid');
      if (!grid) return;
      sessionStorage.setItem(key, JSON.stringify({
        scrollY: window.scrollY,
        path: path,
        html: grid.innerHTML
      }));
    }, { capture: true });
    window.addEventListener('pageshow', () => {
      const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
      if (!saved || saved.path !== path || !saved.html) return;
      const grid = document.querySelector('#filter-results ul.grid');
      if (!grid) return;
      grid.innerHTML = saved.html;
      window.scrollTo({ top: saved.scrollY, behavior: 'auto' });
      sessionStorage.removeItem(key);
    });
  }
  // ===== 5. Sticky header =====
  const selectors = [
    '#template-product .header.bg-theme-bg.text-theme-text.has-motion',
    '#template-cart .header.bg-theme-bg.text-theme-text.has-motion',
    '#template-collection .header.bg-theme-bg.text-theme-text.has-motion'
  ];
  const headers = selectors.map(sel => document.querySelector(sel)).filter(Boolean);
  if (headers.length) {
    const updateHeader = () => headers.forEach(h => h.style.top = window.scrollY === 0 ? '0px' : '0');
    window.addEventListener('scroll', updateHeader);
    updateHeader();
  }
})();